export const dataHooks = {
    input: 'hiddenRadio',
    label: 'radio-label',
    icon: 'radio-icon',
};
//# sourceMappingURL=constants.js.map